module.exports = __webpack_public_path__ + "static/media/rules-puzzle-empty-dark.854f0dc1.png";